export const SET_PATIENTS = "SET_PATIENTS";